export const translations = {
  en: {
    brand: "M16",
    brandTagline: "Premium Mobile & Laptop Accessories",
    // Nav
    home: "Home page",
    shop: "Shop",
    cases: "Cases",
    screen_protectors: "Screen Protectors",
    headphones: "Headphones",
    small_accessories: "Small Accessories",
    chargers: "Chargers",
    power_banks: "Power Banks",
    cart: "Cart",
    login: "Login",
    register: "Sign Up",
    logout: "Logout",
    admin: "Admin",
    myOrders: "My Orders",
    // Hero
    heroEyebrow: "Crafted for the discerning",
    heroTitle: "Accessories that match your device's caliber.",
    heroSub: "Hand-picked phone cases, headphones, chargers, power banks and small accessories. Engineered in detail, delivered across the UAE.",
    shopNow: "Shop Collection",
    exploreCategories: "Explore Categories",
    // Sections
    featured: "Featured Selection",
    featuredSub: "Hand-picked premium pieces",
    categories: "Categories",
    allProducts: "All Products",
    viewAll: "View all",
    // Product
    addToCart: "Add to Cart",
    addedToCart: "Added to cart",
    outOfStock: "Out of stock",
    description: "Description",
    price: "Price",
    quantity: "Quantity",
    // Cart
    yourCart: "Your Cart",
    emptyCart: "Your cart is empty",
    continueShopping: "Continue shopping",
    subtotal: "Subtotal",
    total: "Total",
    checkout: "Checkout",
    remove: "Remove",
    // Checkout
    shippingDetails: "Shipping Details",
    fullName: "Full Name",
    phone: "Phone",
    address: "Address",
    city: "City",
    notes: "Notes (optional)",
    paymentMethod: "Payment Method",
    cod: "Cash on Delivery",
    card: "Credit / Debit Card",
    placeOrder: "Place Order",
    orderSummary: "Order Summary",
    // Auth
    email: "Email",
    password: "Password",
    name: "Name",
    signIn: "Sign In",
    createAccount: "Create Account",
    noAccount: "Don't have an account?",
    haveAccount: "Already have an account?",
    // Status / Success
    orderPlaced: "Order placed successfully",
    orderId: "Order ID",
    thankYou: "Thank you for your order",
    paymentProcessing: "Processing payment...",
    paymentSuccess: "Payment confirmed",
    paymentFailed: "Payment failed",
    // Admin
    adminDashboard: "Admin Dashboard",
    products: "Products",
    orders: "Orders",
    addProduct: "Add Product",
    editProduct: "Edit Product",
    deleteProduct: "Delete",
    save: "Save",
    cancel: "Cancel",
    confirmDeleteTitle: "Delete product?",
    confirmDeleteMsg: "Are you sure you want to delete this product? This cannot be undone.",
    deleted: "Deleted",
    yesDelete: "Yes, delete",
    nameEn: "Name (English)",
    nameAr: "Name (Arabic)",
    descEn: "Description (English)",
    descAr: "Description (Arabic)",
    category: "Category",
    imageUrl: "Image URL",
    stock: "Stock",
    featuredFlag: "Featured",
    customer: "Customer",
    status: "Status",
    date: "Date",
    // misc
    currency: "AED",
    confirm: "Confirm",
    welcomeBack: "Welcome back",
    welcome: "Welcome",
    welcomeTitle: "Welcome to M16",
    welcomeMsg: "Premium phone & laptop accessories — crafted in detail, delivered across the UAE.",
    welcomeOfferEyebrow: "Exclusive new customer offer",
    welcomeOfferTitle: "Get 10% off your first order",
    welcomeOfferCode: "Use code",
    welcomeOfferCopied: "Code copied",
    signUpOrLogin: "Sign up / Sign in",
    continueLater: "Maybe later",
    welcomeBackEyebrow: "Welcome back",
    discountActiveTitle: "Your discount is still active",
    discountActiveMsg: "Use code WELCOME10 for 10% off your order",
    copyCode: "Copy code",
    codeCopied: "Copied!",
    continueAsGuest: "Continue as Guest",
    guestBadge: "Guest",
    farewell: "Thank you for visiting. See you soon!",
    couponCode: "Promo code",
    apply: "Apply",
    couponApplied: "Promo code applied",
    couponInvalid: "Invalid code",
    discount: "Discount",
    discoverMore: "Discover the collection",
    free_shipping: "Free shipping in UAE over AED 200",
    quality_guarantee: "1-month quality guarantee",
    fast_delivery: "Same-day delivery in Dubai",
    contactUs: "Contact us",
    returns: "Returns & Refunds",
    reviews: "Reviews",
    // Loyalty points
    points: "Points",
    pointsPerUnit: "Points per unit",
    myPoints: "My Points",
    pointsBalance: "Points balance",
    earnPointsHint: "You'll earn {n} points with this order",
    pointsEarned: "You earned {n} points!",
    redeemPoints: "Use my points",
    redeemPointsHint: "1 point = {v} AED · min {m} points",
    pointsDiscount: "Points discount",
    pointsTooFew: "You need at least {m} points to redeem",
    usePointsToggle: "Redeem points for a discount",
    availablePoints: "Available",
    loyaltySettings: "Loyalty points",
    pointValueLabel: "Value of 1 point (AED)",
    minRedeemLabel: "Minimum points to redeem",
    loyaltySaved: "Loyalty settings saved",
    // Order tracking
    orderTracking: "Order Tracking",
    trackPending: "Under review",
    trackConfirmed: "Confirmed",
    trackShipped: "Shipped",
    trackDelivered: "Delivered",
    trackCancelled: "Cancelled",
    nextStep: "Next step",
    noOrdersYet: "You have no orders yet",
    orderPointsEarned: "Points earned",
    viewMyOrders: "View my orders",
    // Rewards page
    rewardsTitle: "Rewards Program",
    rewardsSubtitle: "Earn points with every purchase and turn them into real discounts.",
    rewardsNav: "Rewards",
    earnPointsBadge: "Earn +{n} points",
    yourBalance: "Your points balance",
    howToEarn: "How to earn points",
    howToEarnDesc: "Every product gives you points. Points are credited to your account once your order is confirmed — the more you shop, the more you earn.",
    howToRedeem: "How to redeem",
    howToRedeemDesc: "At checkout, switch on \"Redeem points\" to instantly turn your balance into a discount on your order.",
    conversionRate: "Point value",
    onePointEquals: "1 point = {v} AED",
    minToRedeem: "Minimum to redeem: {m} points",
    loginToSeePoints: "Log in to view and earn your points",
    startEarning: "Start shopping",
    worth: "worth",
    soldOut: "Sold out",
    remaining: "Remaining",
    inStockQty: "In stock",
    pointsHistory: "Points history",
    noPointsHistory: "No points activity yet",
    pointsRedeemedLabel: "Redeemed",
    orderLabel: "Order",
    loyaltyTier: "Tier",
    currentTier: "Your tier",
    nextTier: "Next tier",
    pointsToNext: "{n} points to {tier}",
    maxTier: "You've reached the top tier!",
    tierBenefits: "Tier benefits",
    tierMultiplier: "Points multiplier",
    tierExclusiveDiscount: "Exclusive discount",
    tierDiscountRow: "Tier discount",
    lowStock: "Low stock",
    onlyLeft: "Only {n} left",
    manageTiers: "Loyalty tiers",
    tierNameLabel: "Name",
    tierMinLabel: "Min points",
    tierMultLabel: "Multiplier",
    tierDiscLabel: "Discount %",
    lifetimePoints: "Lifetime points",
    tierUpTitle: "Tier up!",
    tierUpDesc: "Congratulations! You've reached a new tier with better perks.",
    tierUpCta: "Awesome!",
    doublePointsBadge: "×{n} points",
    manageCampaign: "Double points campaign",
    campaignEnabled: "Enable campaign",
    campaignName: "Campaign name",
    campaignMultiplier: "Multiplier",
    campaignProducts: "Included products",
    campaignStart: "Start",
    campaignEnd: "End",
    campaignSaved: "Campaign saved",
    campaignLive: "Live now",
    campaignScheduled: "Scheduled / inactive",
  },
  ar: {
    brand: "ام16",
    brandTagline: "إكسسوارات فاخرة للهاتف واللابتوب",
    home: "الصفحة الرئيسية",
    shop: "المتجر",
    cases: "كفرات الهاتف",
    screen_protectors: "شاشات حماية",
    headphones: "السماعات",
    small_accessories: "اكسسوارات صغيرة",
    chargers: "شواحن",
    power_banks: "باور بانك",
    cart: "السلة",
    login: "تسجيل الدخول",
    register: "إنشاء حساب",
    logout: "خروج",
    admin: "الإدارة",
    myOrders: "طلباتي",
    heroEyebrow: "صُنع لمن يقدّر التميّز",
    heroTitle: "إكسسوارات بمستوى جهازك.",
    heroSub: "كفرات وسماعات وشواحن وباور بانك وإكسسوارات صغيرة مختارة بعناية. تصميم دقيق، توصيل سريع داخل الإمارات.",
    shopNow: "تسوّق المجموعة",
    exploreCategories: "استعرض الفئات",
    featured: "المنتجات المميزة",
    featuredSub: "قطع فاخرة مختارة بعناية",
    categories: "الفئات",
    allProducts: "كل المنتجات",
    viewAll: "عرض الكل",
    addToCart: "أضف إلى السلة",
    addedToCart: "أُضيف إلى السلة",
    outOfStock: "غير متوفر",
    description: "الوصف",
    price: "السعر",
    quantity: "الكمية",
    yourCart: "سلتك",
    emptyCart: "السلة فارغة",
    continueShopping: "متابعة التسوق",
    subtotal: "المجموع الفرعي",
    total: "الإجمالي",
    checkout: "إتمام الشراء",
    remove: "حذف",
    shippingDetails: "بيانات الشحن",
    fullName: "الاسم الكامل",
    phone: "الهاتف",
    address: "العنوان",
    city: "المدينة",
    notes: "ملاحظات (اختياري)",
    paymentMethod: "طريقة الدفع",
    cod: "الدفع عند الاستلام",
    card: "بطاقة ائتمانية / مدى",
    placeOrder: "تأكيد الطلب",
    orderSummary: "ملخص الطلب",
    email: "البريد الإلكتروني",
    password: "كلمة المرور",
    name: "الاسم",
    signIn: "دخول",
    createAccount: "إنشاء حساب",
    noAccount: "ليس لديك حساب؟",
    haveAccount: "لديك حساب بالفعل؟",
    orderPlaced: "تم استلام طلبك بنجاح",
    orderId: "رقم الطلب",
    thankYou: "شكراً لطلبك",
    paymentProcessing: "جاري معالجة الدفع...",
    paymentSuccess: "تم تأكيد الدفع",
    paymentFailed: "فشل الدفع",
    adminDashboard: "لوحة الإدارة",
    products: "المنتجات",
    orders: "الطلبات",
    addProduct: "إضافة منتج",
    editProduct: "تعديل المنتج",
    deleteProduct: "حذف",
    save: "حفظ",
    cancel: "إلغاء",
    confirmDeleteTitle: "حذف المنتج؟",
    confirmDeleteMsg: "هل أنت متأكد من حذف هذا المنتج؟ لا يمكن التراجع عن هذه العملية.",
    deleted: "تم الحذف",
    yesDelete: "نعم، احذف",
    nameEn: "الاسم (إنجليزي)",
    nameAr: "الاسم (عربي)",
    descEn: "الوصف (إنجليزي)",
    descAr: "الوصف (عربي)",
    category: "الفئة",
    imageUrl: "رابط الصورة",
    stock: "المخزون",
    featuredFlag: "مميز",
    customer: "العميل",
    status: "الحالة",
    date: "التاريخ",
    currency: "د.إ",
    confirm: "تأكيد",
    welcomeBack: "أهلاً بعودتك",
    welcome: "أهلاً بك",
    welcomeTitle: "مرحباً بك في M16",
    welcomeMsg: "إكسسوارات فاخرة للهاتف واللابتوب — صناعة دقيقة، توصيل لكل الإمارات.",
    welcomeOfferEyebrow: "عرض حصري للعميل الجديد",
    welcomeOfferTitle: "احصل على خصم 10٪ على أول طلب",
    welcomeOfferCode: "استخدم الكود",
    welcomeOfferCopied: "تم نسخ الكود",
    signUpOrLogin: "تسجيل / دخول",
    continueLater: "التسجيل لاحقاً",
    welcomeBackEyebrow: "أهلاً بعودتك",
    discountActiveTitle: "خصمك ما زال متاحاً",
    discountActiveMsg: "استخدم الكود WELCOME10 واحصل على خصم 10٪ على طلبك",
    copyCode: "نسخ الكود",
    codeCopied: "تم النسخ!",
    continueAsGuest: "الدخول كزائر",
    guestBadge: "زائر",
    farewell: "شكراً لزيارتك، نراك قريباً!",
    couponCode: "كود الخصم",
    apply: "تطبيق",
    couponApplied: "تم تطبيق الخصم",
    couponInvalid: "كود غير صالح",
    discount: "الخصم",
    discoverMore: "اكتشف المجموعة",
    free_shipping: "شحن مجاني داخل الإمارات للطلبات فوق 200 د.إ",
    quality_guarantee: "ضمان جودة لمدة شهر",
    fast_delivery: "توصيل في نفس اليوم داخل دبي",
    contactUs: "اتصل بنا",
    returns: "الاسترجاع",
    reviews: "التقييم",
    // نقاط الولاء
    points: "النقاط",
    pointsPerUnit: "النقاط لكل قطعة",
    myPoints: "نقاطي",
    pointsBalance: "رصيد النقاط",
    earnPointsHint: "ستحصل على {n} نقطة مع هذا الطلب",
    pointsEarned: "حصلت على {n} نقطة!",
    redeemPoints: "استخدام نقاطي",
    redeemPointsHint: "النقطة = {v} د.إ · الحد الأدنى {m} نقطة",
    pointsDiscount: "خصم النقاط",
    pointsTooFew: "تحتاج {m} نقطة على الأقل للاستبدال",
    usePointsToggle: "استبدال النقاط بخصم",
    availablePoints: "المتاح",
    loyaltySettings: "نقاط الولاء",
    pointValueLabel: "قيمة النقطة الواحدة (د.إ)",
    minRedeemLabel: "الحد الأدنى من النقاط للاستبدال",
    loyaltySaved: "تم حفظ إعدادات النقاط",
    // تتبّع الطلب
    orderTracking: "تتبّع الطلب",
    trackPending: "قيد المراجعة",
    trackConfirmed: "تم التأكيد",
    trackShipped: "تم الشحن",
    trackDelivered: "تم التوصيل",
    trackCancelled: "ملغي",
    nextStep: "الخطوة التالية",
    noOrdersYet: "لا توجد لديك طلبات بعد",
    orderPointsEarned: "النقاط المكتسبة",
    viewMyOrders: "عرض طلباتي",
    // صفحة المكافآت
    rewardsTitle: "برنامج المكافآت",
    rewardsSubtitle: "اكسب نقاطاً مع كل عملية شراء وحوّلها إلى خصومات حقيقية.",
    rewardsNav: "المكافآت",
    earnPointsBadge: "اكسب +{n} نقطة",
    yourBalance: "رصيد نقاطك",
    howToEarn: "كيف تكسب النقاط",
    howToEarnDesc: "كل منتج يمنحك نقاطاً تُضاف إلى حسابك بمجرد تأكيد طلبك — كل ما اشتريت أكثر كسبت أكثر.",
    howToRedeem: "كيف تستبدل النقاط",
    howToRedeemDesc: "عند الدفع فعّل خيار \"استبدال النقاط\" لتحويل رصيدك فوراً إلى خصم على طلبك.",
    conversionRate: "قيمة النقطة",
    onePointEquals: "النقطة الواحدة = {v} د.إ",
    minToRedeem: "الحد الأدنى للاستبدال: {m} نقطة",
    loginToSeePoints: "سجّل الدخول لعرض نقاطك وكسبها",
    startEarning: "ابدأ التسوّق",
    worth: "قيمتها",
    soldOut: "انتهت الكمية",
    remaining: "المتبقي",
    inStockQty: "المتوفر",
    pointsHistory: "سجل النقاط",
    noPointsHistory: "لا يوجد نشاط نقاط بعد",
    pointsRedeemedLabel: "نقاط مستبدَلة",
    orderLabel: "طلب",
    loyaltyTier: "المستوى",
    currentTier: "مستواك",
    nextTier: "المستوى التالي",
    pointsToNext: "{n} نقطة للوصول إلى {tier}",
    maxTier: "وصلت إلى أعلى مستوى!",
    tierBenefits: "مزايا المستويات",
    tierMultiplier: "مضاعف النقاط",
    tierExclusiveDiscount: "خصم حصري",
    tierDiscountRow: "خصم المستوى",
    lowStock: "كمية منخفضة",
    onlyLeft: "متبقٍ {n} فقط",
    manageTiers: "مستويات الولاء",
    tierNameLabel: "الاسم",
    tierMinLabel: "أقل نقاط",
    tierMultLabel: "المضاعف",
    tierDiscLabel: "نسبة الخصم %",
    lifetimePoints: "إجمالي النقاط",
    tierUpTitle: "ترقية مستوى!",
    tierUpDesc: "تهانينا! وصلت إلى مستوى جديد بمزايا أفضل.",
    tierUpCta: "رائع!",
    doublePointsBadge: "×{n} نقاط",
    manageCampaign: "عرض النقاط المضاعفة",
    campaignEnabled: "تفعيل العرض",
    campaignName: "اسم العرض",
    campaignMultiplier: "المضاعف",
    campaignProducts: "المنتجات المشمولة",
    campaignStart: "البداية",
    campaignEnd: "النهاية",
    campaignSaved: "تم حفظ العرض",
    campaignLive: "نشط الآن",
    campaignScheduled: "مجدول / غير نشط",
  },
};
